export interface ProjectStatus {
  status: string;
  previousStatus?: string;
  metaStatus?: ProjectMetaStatus;
}

export function isProjectStatus(status: unknown): status is ProjectStatus {
  return typeof status === 'object' && status !== null && 'status' in status && typeof status.status === 'string';
}

export type ProjectMetaStatus = 'QUALIFYING' | 'REVIEWING' | 'READY_FOR_DNO' | 'INSTALLED';
